<template>
    <div class="detail-content" ref="middle_page">
        <div class="primarylists list-mobile left-0">
            <div class="titles clear">
                <img src="../../../static/images/icon-st.jpg" alt="" />
                <div class="title l" style="text-transform: uppercase!important;">{{ $t("studySituationList.count") }}</div>
            </div>
        </div>
        <div class="exam_begins_box">
            <div class="exam_begins_rule" :class="{nqt__exam_begins_mb: mobile}">
                <el-form :model="form">
                    <el-form-item label class="font_col" :class="{nqt__ser_mb: mobile}">
                        <el-row class="div-s-ch">
                            <el-col class="div-s-l">
                                <el-input :placeholder="$t('scoreStatistics.courseNameInput')" v-model="keyword" clearable @keyup.enter.native="search_s()">
                                    <template slot="prepend">{{ $t("scoreStatistics.courseName") }}</template>
                                </el-input>
                                <el-button class="btn-s-n" @click="search_s">{{ $t("scoreStatistics.search") }}</el-button>
                            </el-col>
                            <el-col class="div-ch showCompletedCourseCheck" v-if="!mobile">
                                <span class="menu-switch-school lesson_begin" :value="checked" :class="{ 'menu-switch-school-on': checked }" @click="checkedCallBack()"></span>
                                <span @click="checkedCallBack()" class="showCompletedCourseCheckText">{{$t('new.showCompletedCourse')}}</span>
                            </el-col>
                        </el-row>
                        <el-row v-if="mobile" style="padding-bottom: 5px">
                            <el-col class="showCompletedCourseCheck">
                                <span class="menu-switch-school lesson_begin" :value="checked" :class="{ 'menu-switch-school-on': checked }" @click="checkedCallBack()"></span>
                                <span @click="checkedCallBack()" class="showCompletedCourseCheckText">{{$t('new.showCompletedCourse')}}</span>
                            </el-col>
                        </el-row>
                    </el-form-item>
                </el-form>
            </div>
            <div class="course_box">
                <div class="exam_begins_rule_content nqt__pc_table__online">
                    <el-table :data="pagedTableInfo" v-if="this.tableInfo.length > 0" @header-click="sortTable" :header-cell-style="tableHeaderStyle">
                        <el-table-column fixed type="index" :label="$t('courseList.no')" header-align="center" align="center " width="50px">
                            <template slot-scope="scope">{{ (page - 1) * limit + scope.$index + 1 }}</template>
                        </el-table-column>
                        <el-table-column prop="courseName" fixed header-align="center" align="left " :label="$t('scoreStatistics.courseName')" show-overflow-tooltip width="240px" :render-header="icons">
                            <template slot-scope="scope">
                                <span @click="goto_Aicourse(scope.row.courseId)">{{ scope.row.courseName }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="startDate" :label="$t('courseProgress.learnBeginDate')" header-align="center" align="center " min-width="180px" :render-header="icons"></el-table-column>
                        <el-table-column prop="endDate" :label="$t('studySituationList.studentEndDate')" header-align="center" align="center " min-width="180px" :render-header="icons"></el-table-column>
                        <el-table-column prop="finished" :label="$t('courseProgress.complete')" header-align="center" align="center " min-width="140px" :render-header="icons"></el-table-column>
                        <el-table-column prop="learningProcess" :label="$t('courseProgress.learningProcess')" header-align="center" align="center " min-width="140px" :render-header="icons">
                            <template slot-scope="scope" align="right">
                                <el-progress :percentage="Number(scope.row.learningProcess)" :stroke-width="20" :text-inside="true" :color="setColor(Number(scope.row.learningProcess))"></el-progress>
                            </template>
                        </el-table-column>
                        <el-table-column prop="isQuestionnaire" header-align="center" align="center " :label="$t('courseProgress.isquestion')" min-width="90px" width="150" :render-header="icons">
                            <template slot-scope="scope">
                                <span v-if="scope.row.isQuestionnaire == 1">{{ $t("studySituationList.raised") }}</span>
                                <span v-if="scope.row.isQuestionnaire == 2">{{ $t("studySituationList.notRaised") }}</span>
                                <span v-if="scope.row.isQuestionnaire == 0">-</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="isCertificate" header-align="center" align="center " :label="$t('studySituationList.guarantee')" width="150" :render-header="icons">
                            <template slot-scope="scope">
                                <span v-if="scope.row.isCertificate == 1">{{ $t("studySituationList.raised") }}</span>
                                <span v-if="scope.row.isCertificate == 2">{{ $t("studySituationList.notRaised") }}</span>
                                <span v-if="scope.row.isCertificate == 0">-</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="isQuestion" header-align="center" align="center " :label="$t('studySituationList.certificate')" width="150">
                            <template slot-scope="scope">
                                <el-button v-if="scope.row.isPass == 1 && scope.row.unfinished == 1" type="text" size="small">
                                    <span style="cursor: pointer;">
                                        <a @click="downLoad(scope.row.courseId, scope.row.courseName)" target="_blank">{{ $t("community.down") }}</a>
                                    </span>
                                </el-button>
                                <span v-if="scope.row.isPass != 1 || scope.row.unfinished != 1">-</span>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-col :span="24" class="toolbar" style="text-align: center;" v-if="this.tableInfo.length > 0">
                        <el-pagination @current-change="handleCurrentChange" :current-page="pageNum" :page-size="pageSize" layout="prev, pager, next" :total="this.tableInfo.length" background></el-pagination>
                    </el-col>
                </div>
            </div>
            <!-- mobile course_box -->
            <div class="course_box_mobile">
                <div class="box-1" @click="activeRow(index)" v-for="(item, index) in pagedTableInfo" :key="item.value">
                    <div class="title_course_box" :class="{'turn-arrow': activeID == index}">
                        <div class="num_order">
                            {{ (page - 1) * limit + index + 1 }}
                        </div>
                        <div class="title_course">
                            {{ item.courseName }}
                        </div>
                    </div>
                    <div class="content_box" :class="{'active-content': activeID == index}">
                        <div class="content_new">
                            <h1>{{ $t("courseProgress.learnBeginDate") }}:</h1>
                            <span>{{ item.startDate }}</span>
                        </div>
                        <div class="content_new">
                            <h1>{{ $t("studySituationList.studentEndDate") }}:</h1>
                            <span>{{ item.endDate }}</span>
                        </div>
                        <div class="content_new">
                            <h1>{{ $t("courseProgress.complete") }}:</h1>
                            <span>{{ item.finished }}</span>
                        </div>
                        <div class="content_new">
                            <h1>{{ $t("courseProgress.learningProcess") }}:</h1>
                            <span>{{ item.learningProcess }}%</span>
                        </div>
                        <div class="content_new">
                            <h1>{{ $t("courseProgress.isquestion") }}:</h1>
                            <span v-if="item.isQuestionnaire == 1">{{ $t("studySituationList.raised") }}</span>
                            <span v-if="item.isQuestionnaire == 2">{{ $t("studySituationList.notRaised") }}</span>
                            <span v-if="item.isQuestionnaire == 0">-</span>
                        </div>
                        <div class="content_new">
                            <h1>{{ $t("studySituationList.guarantee") }}:</h1>
                            <span v-if="item.isCertificate == 1">{{ $t("studySituationList.raised") }}</span>
                            <span v-if="item.isCertificate == 2">{{ $t("studySituationList.notRaised") }}</span>
                            <span v-if="item.isCertificate == 0">-</span>
                        </div>
                        <!-- <div class="content_new">
                            <h1>{{ $t("studySituationList.certificate") }}:</h1>
                            <button class="btn-studySituationList" v-if="item.isPass == 1 && item.unfinished == 1" @click="downLoad(item.courseId, item.courseName)">
                                {{ $t("community.down") }}
                            </button>
                            <span v-if="item.isPass != 1 || item.unfinished != 1">-</span>
                        </div> -->
                        <div class="content_new"></div>
                        <div class="btn-course" @click="goto_Aicourse(item.courseId)">
                            <span>{{ $t("home.clickJump") }}</span>
                        </div>
                    </div>
                </div>
                <el-col :span="24" class="toolbar" style="text-align: center;" v-if="this.tableInfo.length > 0">
                    <el-pagination @current-change="handleCurrentChange" :current-page="pageNum" :page-size="pageSize" layout="prev, pager, next" :total="this.tableInfo.length" background></el-pagination>
                </el-col>
            </div>
            <!-- end mobile course_box-->
            <div v-if="!this.tableInfo.length > 0 && checkSearch == true" class="no-content">
                <img src="/static/images/noresult.jpg" alt />
                <p>{{ $t("search.result") }}</p>
            </div>
        </div>
        <!-- Loading -->
        <loading :showLoading="loading" />
    </div>
</template>

<script>
    import Vue from "vue";
    import { mapMutations } from "vuex";
    import { lang } from "../../assets/languages/getLanguageType.js";
    Vue.prototype.$lang = lang;
    import en from "element-ui/lib/locale/lang/en";
    import ja from "element-ui/lib/locale/lang/ja";
    import vi from "element-ui/lib/locale/lang/vi";
    import zh from "element-ui/lib/locale/lang/zh-CN";
    import picker from "../../../node_modules/element-ui/lib/locale/index";
    import loading from "@/components/loading/loading";
    import md5 from "js-md5";
    export default {
        name: "course_score_statistics",
        components: {
            loading,
        },
        data() {
            return {
                startDate: {
                    disabledDate: (time) => {
                        if (this.form.createEndTime) {
                            return time.getTime() > new Date(this.form.createEndTime).getTime();
                        }
                    },
                },
                endDate: {
                    disabledDate: (time) => {
                        if (this.form.createBeginTime) {
                            return time.getTime() < new Date(this.form.createEndTime).getTime() - 20 * 3600 * 1000;
                        } else {
                            return time.getTime() < Date.now();
                        }
                    },
                },
                form: {
                    courseName: "",
                },
                resultFlag: false,
                pageNum: 1,
                pageSize: 10,
                totalPage: 0,
                searchResultList: [],
                total: 14,
                page: 1,
                limit: 10,
                item: null,
                userId: null,
                courseId: null,
                courseName: null,
                manyInfo: [],
                tableInfo: [],
                calendarClickList: [],
                calendarClickList1: [],
                keyword: null,
                startOfValidity: null,
                endOfValidity: null,
                checked: false,
                area: null,
                name: null,
                gender: null,
                checkSearch: false,
                checkListRespone: false,
                activeID: null,
                asc: true,
                listSort: [
                    {
                        colName: "courseName",
                        asc: true,
                    },
                    {
                        colName: "startDate",
                        asc: true,
                    },
                    {
                        colName: "endDate",
                        asc: true,
                    },
                    {
                        colName: "finished",
                        asc: true,
                    },
                    {
                        colName: "learningProcess",
                        asc: true,
                    },
                    {
                        colName: "isQuestionnaire",
                        asc: true,
                    },
                    {
                        colName: "isCertificate",
                        asc: true,
                    },
                ],
                loading: true
            };
        },
        computed: {
            pagedTableInfo() {
                return this.tableInfo.slice(this.pageSize * this.page - this.pageSize, this.pageSize * this.page);
            },
            mobile () {
                return this.$store.getters['header/mobile'];
            }
        },
        mounted() {
            if (this.$lang() == "1") {
                picker.use(zh);
            } else if (this.$lang() == "2") {
                picker.use(en);
            } else if (this.$lang() == "3") {
                picker.use(ja);
            } else if (this.$lang() == "4") {
                picker.use(vi);
            } else {
                picker.use(en);
            }

            const h = document.body.clientHeight - 50;

            this.$autoLogin().then(
                () => {
                    this.courseId = this.$route.query.courseId;
                    this.userId = window.sessionStorage.getItem("id");
                    this.role = window.sessionStorage.getItem("role");
                    (this.area = window.sessionStorage.getItem("area")), (this.name = window.sessionStorage.getItem("name")), (this.gender = window.sessionStorage.getItem("gender"));
                    this.loading = true
                    this.$api
                        .post("/home/getCourseAnalysis", {
                            languageType: this.$lang()
                        })
                        .then((response) => {
                            if (response.meta.success == true) {
                                this.loading = false
                            }
                            if (response.data.list.length > 0) {
                                this.resultFlag = true;
                                this.totalPage = response.data.total;
                                this.tableInfo = this.sortedTables(response.data.list, "learningProcess", this.asc);
                                this.checkListRespone = true;
                            } else {
                                this.totalPage = 0;
                                this.tableInfo = [];
                                this.resultFlag = false;
                            }
                            document.getElementById("app").scrollTo(0, 0);
                        });
                },
                () => {
                    this.$router.push({
                        path: "/home",
                    });
                    this.$message.warning(window.vm.$i18n.t("read.login"));
                }
            );
        },
        methods: {
            tableHeaderStyle({ columnIndex }) {
                if (columnIndex != 0 && columnIndex != 8) return "cursor: pointer";
            },
            sortTable(column) {
                if (column.property != undefined && column.property != "isQuestion") {
                    let key = this.listSort.findIndex((item) => item.colName == column.property);
                    this.listSort[key].asc = !this.listSort[key].asc;
                    this.tableInfo = this.sortedTables(this.tableInfo, column.property, this.listSort[key].asc);
                }
            },
            sortedTables(data, element, type) {
                if (element == "learningProcess" || element == "finished") {
                    if (type) {
                        return data.sort((a, b) => {
                            if (a[element] === null) {
                                return parseInt("0") - parseInt(b[element]);
                            } else if (b[element] === null) {
                                return parseInt(a[element]) - parseInt("0");
                            } else {
                                return parseInt(a[element]) - parseInt(b[element]);
                            }
                        });
                    } else {
                        return data.sort((a, b) => {
                            if (a[element] == null) {
                                return parseInt(b[element]) - parseInt("0");
                            } else if (b[element] == null) {
                                return parseInt("0") - parseInt(a[element]);
                            } else {
                                return parseInt(b[element]) - parseInt(a[element]);
                            }
                        });
                    }
                }
                return type ? data.sort((a, b) => a[element].localeCompare(b[element])) : data.sort((a, b) => b[element].localeCompare(a[element]));
            },
            icons(h, { column }) {
                return [
                    h("span", column.label),
                    h("i", {
                        class: "el-icon-d-caret",
                        style: "color:#ffffff;margin-left:3px;",
                    }),
                ];
            },
            setColor(learningProcess) {
                if (Number(learningProcess) >= 80) {
                    return "#67C23A";
                } else if (Number(learningProcess) < 80 && Number(learningProcess) >= 60) {
                    return "#409EFF";
                } else if (Number(learningProcess) < 60 && Number(learningProcess) >= 40) {
                    return "#FFCC00";
                } else if (Number(learningProcess) < 40 && Number(learningProcess) >= 20) {
                    return "#FF6600";
                } else if (Number(learningProcess) < 20) {
                    return "#FF3300";
                }
            },
            checkedCallBack(e, checkedFresh) {
                this.checked = !this.checked;
                this.search_s();
            },
            search() {
                this.loading = true
                this.$api
                    .post("/home/getCourseAnalysis", {
                        startOfValidity: this.startOfValidity,
                        endOfValidity: this.endOfValidity,
                        keyword: this.keyword,
                        userId: this.userId,
                        languageType: this.$lang(),
                        checked: this.checked,
                    })
                    .then((response) => {
                        if (response.meta.success == true) {
                                this.loading = false
                        }
                        if (response.data.list.length > 0) {
                            this.resultFlag = true;
                            this.totalPage = response.data.total;
                            this.tableInfo = this.sortedTables(response.data.list, "learningProcess", this.asc);
                        } else {
                            this.totalPage = 0;
                            this.tableInfo = [];
                            this.resultFlag = false;
                            this.checkSearch = true;
                        }
                        document.getElementById("app").scrollTo(0, 0);
                    });
            },
            search_s() {
                this.pageNum = 1;
                this.page = 1;
                this.search();
            },
            startCalendarClick(val) {},
            endCalendarClick(val) {},
            handleCurrentChange(val) {
                this.page = val;
                this.pageNum = val;
                this.activeID = null;
            },
            float: function (comp, uncomp) {
                let num = (comp / (comp + uncomp)) * 100;
                return num.toFixed(1);
            },
            ...mapMutations("header", ["setHistory"]),
            goto_Aicourse: function (courseId) {
                window.sessionStorage.setItem("courseGOBackNum", 5);
                this.setHistory("/home/studySituationList");
                this.$router.push({
                    name: "Aicourse",
                    query: {
                        buyCourseId: courseId,
                        buyCollegeId: JSON.stringify(1),
                    },
                });
            },
            getInfoUser() {
                return new Promise((resolve, reject) => {
                    this.showLoadingFlg = true;
                    this.$api
                    .post("/personalCenter/getPersonalInfo", {
                        rToken:md5(window.sessionStorage.getItem("email")),
                        languageType:this.$lang(),
                    })
                    .then((response) => {
                        resolve(response.data)
                    })
                    .catch((err) => {
                        reject(err.response);
                    });
                });
            },
            async downLoad (courseId, courseName) {
                const userInfo = await this.getInfoUser();
                this.$api
                    .post("/home/certificateExport", {
                        id: courseId,
                        courseName: courseName,
                        courseLanguage: this.$lang(),
                        area: this.$lang(),
                        name: this.name,
                        gender: this.gender,
                        companyId: window.sessionStorage.getItem("companyId"),
                        jobs: userInfo.job
                    })
                    .then((response) => {
                        if (response.data != null) {
                            window.open(response.data);
                        } else {
                            this.$message.warning(window.vm.$i18n.t("js.certificateDataNone"));
                        }
                    })
                    .catch((error) => {
                    });
            },
            activeRow: function (activeID) {
                if (this.activeID == activeID && this.activeID != null) {
                    this.activeID = null;
                } else {
                    this.activeID = activeID;
                }
            },
        },
    };
</script>

<style scoped="scoped">
  .nqt__exam_begins_mb {
    padding-top: 0 !important;
  }
  .nqt__ser_mb {
    padding: 10px !important;
    margin-bottom: 0 !important;
  }
  .div-ch {
    align-self: center;
  }
  .page-bk-col {
      background-color: #ffffff;
  }
  .font_col {
      text-align: center;
      color: #fff;
  }
  .exam_page {
      width: 100%;
      background: url(/static/images/bg/personset_bg.jpg);
      background-size: cover;
      background-repeat: no-repeat;
      display: flex;
      position: relative;
      min-height: 100vh;
  }

  .exam_main {
      background-color: rgb(65, 65, 65, 0.5);
      width: 100%;
      height: 100%;
      padding-bottom: 50px;
      min-height: calc(100vh - 50px);
  }

  .examPage {
      width: 100%;
      margin: 0 auto;
      padding-top: 20px;
  }

  .examCenter_img {
      margin-top: 40px;
      width: 40%;
      margin-left: calc(20% - 30px);
      position: relative;
  }

  .examCenter_img img {
      height: 120px;
  }

  .examCenter_img p:first-child {
      font-size: 40px;
      color: #fafafa;
      font-family: marzo-w00-regular, fantasy;
      font-weight: 400;
  }

  .examCenter_img p:first-child span {
      font-size: 40px;
      color: #ff5252;
      font-family: braggadocio-w01, fantasy;
      font-weight: 400;
  }

  .examCenter_img p:nth-child(2) {
      font-size: 45px;
      color: #e8e6e6;
      font-family: roboto-thin, roboto, sans-serif;
      font-weight: 400;
  }

  .exam_begins_box {
      width: 95%;
      padding: 30px;
      border-radius: 15px;
      margin: 0 auto;
      margin-top: 80px;
      background-color: rgba(0, 0, 0, 0.3);
      box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.3);
      position: relative;
  }

  .course_box {
      width: 100%;
      border-radius: 15px;
      /* background-color: rgba(0, 0, 0, 0.3); */
      /* box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.3); */
      position: relative;
      margin-bottom: 20px;
  }

  .exam_page_span {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      background-color: rgba(0, 0, 0, 0.3);
  }

  .examination_notes {
      height: 20px;
      font-size: 20px;
      color: #e8e6e6;
      text-align: center;
      font-weight: 200;
      font-style: normal;
  }

  .exam_begins_box .exam_begins_rule {
      position: relative;
      /* display: -webkit-flex; */
      margin-top: 20px;
      padding-top: 20px;
      border-top: 1px #414141 solid;
  }

  .exam_begins_rule .exam_begins_rule_title {
      width: auto;
      height: 20px;
      margin-right: 10px;
      font-size: 14px;
      color: #e8e6e6;
      font-family: source-han-sans-simplified-c, sans-serif;
      font-weight: 200;
      font-style: normal;
  }

  .exam_begins_rule .exam_begins_rule_content {
      width: 520px;
      min-height: 20px;
      position: relative;
      display: block;
  }

  .exam_begins_rule .exam_begins_rule_content p {
      min-height: 20px;
      line-height: 20px;
      display: flex;
      font-size: 14px;
      color: #e8e6e6;
      text-align: left;
      font-family: source-han-sans-simplified-c, sans-serif;
      font-weight: 200;
      font-style: normal;
  }

  .exam_notes {
      height: 20px;
      line-height: 20px;
      font-size: 14px;
      color: #e8e6e6;
      text-align: center;
      font-family: source-han-sans-simplified-c, sans-serif;
      font-weight: 200;
      font-style: normal;
  }

  .exam_notes:first-child {
      margin-top: 40px;
  }

  .exam_btn {
      margin: 0 auto;
      margin-top: 3px;
      display: block;
      text-align: center;
      font-size: 16px;
      color: #fff;
      padding: 6px 20px;
      border-radius: 20px;
      transition: 0.5s ease;
      border: 1px solid #00d3ff;
      background-image: -webkit-linear-gradient(315deg, #00d3ff 0%, #02adff 100%);
      background-image: linear-gradient(135deg, #00d3ff 0%, #02adff 100%);
  }

  .exam_btn:hover {
      color: #000;
      background-color: #fff;
      transition: 0.5s ease;
  }
  .item {
      margin-top: 0px;
      margin-right: 0px;
      margin-left: 0px;
  }
  .has-gutter tr td {
      background: #f30;
  }
  .el-table >>> .has-gutter tr th {
      background-image: -webkit-linear-gradient(0deg, #e8e6e6 0%, #fff 100%);
      background-image: linear-gradient(0deg, #e8e6e6 0%, #fff 100%);
  }
  .el-table >>> .el-table__header thead tr th {
      background-image: -webkit-linear-gradient(0deg, #e8e6e6 0%, #fff 100%);
      background-image: linear-gradient(0deg, #e8e6e6 0%, #fff 100%);
  }
  .el-table >>> .cell .el-button span {
      background-image: -webkit-linear-gradient(315deg, #02adff 0%, #00d3ff 100%);
      background-image: linear-gradient(135deg, #02adff 0%, #00d3ff 100%);
      color: #fff;
      padding: 3px 8px;
      border-radius: 15px;
      -webkit-transition: 0.5s ease;
      transition: 0.5s ease;
  }
  .el-table >>> .cell .el-button span:hover {
      color: #333;
  }

  .toolbar >>> .el-pagination {
      margin-top: 8px;
  }
  .toolbar >>> .el-pagination .btn-next,
  .toolbar >>> .el-pagination .btn-prev {
      border-radius: 5px;
      background: unset;
      color: #fff;
  }
  .toolbar >>> .el-pager li {
      min-width: unset;
      margin: 0 5px;
  }
  .curriculum_img {
      cursor: pointer;
      width: 20px;
      height: 20px;
      margin-top: -3px;
      margin-right: 3px;
      display: inline-block;
      vertical-align: middle;
  }
  @media screen and (max-width: 1024px) {
      .examPage {
          width: calc(100% - 60px);
      }
      .exam_begins_box {
          width: 94%;
          min-width: 500px;
          padding: 3%;
      }
      .form-item {
          margin-left: 0px;
      }
      .el-col-7,
      .el-col-6 {
          text-align: left;
          min-width: 100px;
          width: unset;
      }
  }
  /* switch */
  .menu-switch-school {
    display: block;
    position: relative;
    width: 46px;
    height: 27px;
    border: 1px solid #dfdfdf;
    outline: 0;
    border-radius: 16px;
    box-sizing: border-box;
    background-color: #dfdfdf;
    transition: background-color 0.1s, border 0.1s;
    cursor: pointer;
  }
  .menu-switch-school:before {
    content: " ";
    position: absolute;
    top: 0;
    left: 0;
    width: 44px;
    height: 25px;
    border-radius: 15px;
    transition: transform 0.35s cubic-bezier(0.45, 1, 0.4, 1);
  }
  .menu-switch-school:after {
    content: " ";
    position: absolute;
    top: 0;
    left: 0;
    width: 24px;
    height: 24px;
    border-radius: 15px;
    background-color: #ffffff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
    transition: transform 0.35s cubic-bezier(0.4, 0.4, 0.25, 1.35);
  }
  .menu-switch-school-on {
    border-color: #79c9ff;
    background-color: #79c9ff;
  }
  .lesson_begin.menu-switch-school-on:before {
    border-color: #79c9ff;
    background-color: #79c9ff;
  }
  .lesson_learning.menu-switch-school-on:before {
    border-color: #da251d;
    background-color: #da251d;
  }
  .lesson_end.menu-switch-school-on:before {
    border-color: #118e07;
    background-color: #118e07;
  }
  .menu-switch-school-on:after {
    transform: translateX(20px);
  }
  .lesson_begin.menu-switch-school-on:before {
    border-color: #79c9ff;
    background-color: #79c9ff;
  }
  .showCompletedCourseCheck {
    display: flex;
  }
  .showCompletedCourseCheckText {
    color: rgb(0, 0, 0);
    margin-left: 7px;
    margin-top: -6px;
  }
  .btn-studySituationList{
    background-image: linear-gradient(135deg, #02adff 0%, #00d3ff 100%);
    color: #fff;
    padding: 3px 8px;
    border-radius: 15px;
    transition: 0.5s ease;
    border: 0;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/studysituation/studySituationList.vue